module.exports = {

    init: function () {
        
        // console.log('BannerSlider is working...');
        
        jQuery('.owl-carousel').owlCarousel({
            items: 1,
            margin: 0,
            singleItem: true,
            autoplay: true,
            dotsContainer: '.dots-container'
        });
        
    }

};